import script from "./CourseItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseItem.vue?vue&type=script&setup=true&lang=ts"

import "./CourseItem.vue?vue&type=style&index=0&id=49ef5340&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ef5340"]])

export default __exports__